import {  Select } from 'antd';
import { ArrowDownIcon } from '../../../../assets/icons/common/common-icons';
import { ModifiedSelectClearIcon } from '../../../../common/components/ModifiedSelectClearIcon/ModifiedSelectClearIcon';
import { EditHoldingEntityInputRow, InputWithLabelOnTopWrapper, HoldingEntityTypeCustomSelect } from '../../../entities/EditHoldingEntity/EditHoldingEntity.styles';

export const HoldingEntitySelect = (props) => {
    const { value, onTypeChange, formErrors, title, options, placeholder } = props;
    const { Option } = Select;

    return (
        <EditHoldingEntityInputRow>
            <InputWithLabelOnTopWrapper withError={formErrors.holdingEntityType}>
                <HoldingEntityTypeCustomSelect
                    title={title}
                    optionFilterProp='label'
                    optionLabelProp='label'
                    labelInValue={false}
                    name='holdingEntityType'
                    placeholder={placeholder}
                    value={value}
                    onChange={(val) => onTypeChange(val)}
                    suffixIcon={<ArrowDownIcon />}
                    allowClear={true}
                    clearIcon={<ModifiedSelectClearIcon title={`Clear ${title.toLowerCase()}`} />}
                    dropdownClassName='holdingEntitySelectDropdown'
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                >
                    {Object.entries(options).map(([key, value]) => (
                        <Option key={key} value={key} label={<div style={{ fontWeight: '450' }}>{value.title}</div>} >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '8px 0' }}>
                                <div style={{ color: '#1A1B1D', fontSize: '14px', fontWeight: '450', lineHeight: 'normal' }}>{value.title}</div>
                                {value === key && (
                                    <div style={{ marginLeft: 'auto' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
                                            <path d="M11.5106 1.104L4.5061 8.1125L1.00008 4.60754" stroke="black" strokeWidth="2" />
                                        </svg>
                                    </div>
                                )}
                            </div>
                        </Option>
                    ))}
                </HoldingEntityTypeCustomSelect>
            </InputWithLabelOnTopWrapper>
        </EditHoldingEntityInputRow>
    )
}